import intro2 from "images/IntroDuction2.jpg";
import NcImage from "shared/NcImage/NcImage";
export default function SectionOurExperience() {
  return (
    <div className="container grid grid-cols-12 gap-5 py-8 items-center">
      <div className="col-span-12 lg:col-span-6">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight">
          <span className="text-primary-500 mr-3">35+ Years</span>
          Manufacturing Experience
        </h2>

        <p className="mt-5 text-sm sm:text-base md:text-lg lg:text-xl text-justify leading-relaxed max-w-prose">
          With over <strong>35 years of manufacturing experience</strong>,
          <strong> Devi Plastic</strong> has built a strong reputation as a
          reliable
          <strong> sink coupling manufacturer</strong> in
          <strong> Ahmedabad, Gujarat (India)</strong>. Our long-standing
          presence in the industry reflects our commitment to quality,
          consistency, and customer satisfaction.
        </p>

        <p className="mt-4 text-sm sm:text-base md:text-lg lg:text-xl text-justify leading-relaxed max-w-prose">
          We specialize in the production of{" "}
          <strong>plastic sink waste couplings</strong>,
          <strong> heavy, lite, jumbo, and royal sink couplings</strong>, along
          with
          <strong> custom die making</strong> and{" "}
          <strong>steel & plastic component manufacturing</strong>. Our
          experience enables us to deliver precision-built products that meet
          both domestic and industrial standards across India.
        </p>
      </div>
      <div className="col-span-12 lg:col-span-6 flex items-center justify-center">
        <NcImage
          src={intro2}
          alt="Devi Plastic manufacturing unit – sink coupling and die making manufacturer in Ahmedabad"
          className="w-full h-auto max-h-80 sm:max-h-96 object-contain rounded-md"
        />
      </div>
    </div>
  );
}
